import { createFileRoute } from "@tanstack/react-router";

const WorkspaceSettingsBasicsRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/workspace/")({
	component: WorkspaceSettingsBasicsRoute,
});
